<template>
  <tippy-tooltip :class="$attrs.class">
    <tippy-bounce-button
      v-bind="{...$attrs, class: undefined}"
      class="w-100"
      store-key="upload-recording-button:clicked"
      tippy-content="Click to upload"
      :tippy-options="{placement: 'right'}"
      @click="onClick"
    >
      <img
        :src="UploadIcon"
        alt=""
      />
    </tippy-bounce-button>
    <template #content>
      <span>Upload</span>
      <kbd class="bg-white text-black-50 ml-1">enter</kbd>
    </template>
  </tippy-tooltip>
</template>

<script>
import { onKeyStroke } from '@vueuse/core'
import TippyTooltip from '../../../common/tippy-tooltip.vue'
import TippyBounceButton from '../../../common/tippy-bounce-button.vue'
import { UploadIcon } from '../../../common/icons'

export default {
  name: 'WebcamRecorderUploadRecordingButton',
  components: {
    TippyBounceButton,
    TippyTooltip
  },
  inheritAttrs: false,
  emits: ['click'],
  setup (_, { emit }) {
    const onClick = () => {
      emit('click')
    }

    onKeyStroke('Enter', () => {
      onClick()
    })

    return {
      UploadIcon,
      onClick
    }
  }
}
</script>
